"use client"

import { useMemo } from "react"
import { usePathname } from "next/navigation"
import {
  defaultLocale,
  getEnabledLocales,
  getPathLocale,
  isEnabledBlogLocale,
  isEnabledLocale,
  stripLocaleFromPath,
  type UiLocale,
} from "@/shared/lib/i18n/config"

export function useCurrentLocale(): UiLocale {
  const pathname = usePathname()

  return useMemo(() => {
    const pathLocale = getPathLocale(pathname ?? "/")
    const normalizedPath = pathLocale ? stripLocaleFromPath(pathname ?? "/") : pathname ?? "/"
    const isBlogRoute = normalizedPath === "/blog" || normalizedPath.startsWith("/blog/")

    if (pathLocale && isEnabledLocale(pathLocale)) return pathLocale
    if (
      pathLocale &&
      isEnabledBlogLocale(pathLocale) &&
      isBlogRoute
    ) {
      return pathLocale
    }

    if (isBlogRoute) return defaultLocale

    if (typeof document !== "undefined") {
      const match = document.cookie
        .split(";")
        .map((part) => part.trim())
        .find((part) => part.startsWith("NEXT_LOCALE="))
      const cookieLocale = decodeURIComponent(match?.split("=")[1] ?? "")
      if (isEnabledLocale(cookieLocale)) return cookieLocale
    }

    const enabled = getEnabledLocales()
    return enabled.includes(defaultLocale) ? defaultLocale : enabled[0] ?? defaultLocale
  }, [pathname])
}
